export default __webpack_public_path__ + "static/media/gb-wls.d4bfee4a.svg";